@if (isLoading) {
  <ion-card>
    <app-loader />
  </ion-card>
}

@if (!isLoading) {
  <div class="card-container" data-cy="dashboard-task-list">
    <!-- Mobile view -->
    <ion-card (click)="emitClick()" (keyup)="emitClick()" class="open-tasks-card mobile-only">
      @if (numberOfOpenTasks > 0) {
        @if (numberOfOpenTasks === 1) {
          Er staat <b>1</b> open klus op de klussenlijst
        } @else {
          Er staan <b>{{ numberOfOpenTasks }}</b> open klussen op de klussenlijst
        }
      } @else {
        Geen open klussen op de klussenlijst
      }
      @if (numberOfTasksWithNewComments > 0) {
        <div class="new-comments-signal">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          @if (numberOfTasksWithNewComments === 1) {
            <span><b>1</b> open klus met nieuwe reacties</span>
          } @else {
            <span><b>{{ numberOfTasksWithNewComments }}</b> open klussen met nieuwe reacties</span>
          }
        </div>
      }
      <div class="bottom-button">
        <ng-container>
          <ion-icon name="arrow-forward-outline" style="margin-right: 8px;"></ion-icon>
          Bekijk klussenlijst
        </ng-container>
      </div>
    </ion-card>
    <!-- Desktop view -->
    <ion-card class="desktop-only tasklist-card">
      <ion-card-header>
        Klussenlijst
      </ion-card-header>
      @if (numberOfOpenTasks > 0) {
        <div style=" text-align: center; margin-bottom: 1em;">
          @if (numberOfOpenTasks === 1) {
            Er staat <b>1</b> open klus op de klussenlijst
          } @else {
            Er staan <b>{{ numberOfOpenTasks }}</b> open klussen op de klussenlijst
          }
        </div>
      } @else {
        Geen open klussen op de klussenlijst
      }
      @if (numberOfTasksWithNewComments > 0) {
        <div class="new-comments-signal" style="justify-content: center; margin-bottom: 1em;">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          @if (numberOfTasksWithNewComments === 1) {
            <span><b>1</b> open klus met nieuwe reacties</span>
          } @else {
            <span><b>{{ numberOfTasksWithNewComments }}</b> open klussen met nieuwe reacties</span>
          }
        </div>
      }
      <app-tasklist [showPriorities]="true" [tasks]="tasks" [viewCreationDate]="true" />
      <div class="bottom-button" style="margin-top:16px;">
        <ion-button (click)="emitClick()" expand="block" fill="clear">
          <ion-icon name="arrow-forward-outline" style="margin-right: 8px;"></ion-icon>
          Bekijk klussenlijst
        </ion-button>
      </div>
    </ion-card>
  </div>
}

